import { render, staticRenderFns } from "./InviteFriendsShowBalance.vue?vue&type=template&id=03a97d84&scoped=true&"
import script from "./InviteFriendsShowBalance.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsShowBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a97d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
